const Token = function(DS) {
    return DS.defineResource({
        name: 'Token',
        endpoint: '/token'
    });
};

Token.$inject = ['DS'];

export { Token };



// WEBPACK FOOTER //
// ./app/models/tokens.js